import React, { PureComponent } from "react";
import MgmtLayout from "../../../../components/layouts/MgmtLayout";
import { withRouter } from 'react-router-dom'
import { Row, Col, Table, Card, DatePicker, Select, Typography, Form } from 'antd';
import { Button } from "../../../../components";
import { CSVLink } from "react-csv";
import moment from 'moment';
import Moment from 'moment';
import StorageService from "../../../../app/service/storageService";
import PlateService from "../../../../app/service/plateService";
import ReportsService from "../../../../app/service/reportsService";
import AuthContext from "../../../../main/authenticationProvider";
import { TableSearch } from "../../../../hooks";
import CmdService from "../../../../app/service/cmdService";
import MgmtService from "../../../../app/service/mgmtService";
import { messageError } from "../../../../components/toastr";


const { Title } = Typography;

class MgmtHourmeter extends PureComponent {
    constructor(props) {
        super(props);
        this.servicePlate = new PlateService();
        this.reportsService = new ReportsService();
        this.auth = new AuthContext();
        this.tableSearch = new TableSearch();
        this.cmdService = new CmdService();
        this.mgmtService = new MgmtService();

        this.timer = null;

        this.state = {
            horimeters: [],
            showLoading: false,
            loading: false,
            tablePageSize: 10,
            totalRegisters: 0,
            endDate: Moment().add(1, 'days'),
            startDate: Moment().subtract(7, 'days'),
            plate: StorageService.getItem("plateName") != null ? StorageService.getItem("plateName") : "",
            plates: [],
            chosenPlate: "",
            lastDateConfig: "",
            lastValueConfig: "",
        }

        this.hourmeterForm = React.createRef();
    }

    getCsv = (temp) => {
        let opt = [];
        temp.map((element, index) => {
            opt.push({
                key: index,
                placa: element.plate,
                data: element.date,
                incremento_do_dia: element.accumulationDay,
                valor_ao_final_do_dia: element.accumulation,
                primeiro_horario: element.firstPositionMessage,
                ultimo_horario: element.lastPositionMessage
            });
        });
        return opt;
    }

    getPlates = () => {
        this.mgmtService
            .getPlates()
            .then(response => {
                let opt = [];
                response.data.data.forEach(item => {
                    opt.push({
                        value: item.plate,
                        label: item.plate
                    });
                });
                this.setState({
                    plates: opt,
                    loading: true,
                });

            })
            .catch(erros => {
                this.setState({
                    loading: false,
                });
                erros && erros.response && this.auth.verifyAuth(erros.response.status);
            })
    }

    getData = (startDate, endDate, plate) => {
        this.setState({
            showLoading: true,
            totalPages: 0
        });
        let horimeters = [];

        const data = {
            "plate": plate,
            "startDate": startDate,
            "endDate": endDate,

        }
        this.mgmtService
            .getHorimeterHistory(data)
            .then(response => {
                response.data.data.map((element, index) => {
                    horimeters.push({
                        key: index,
                        date: element.date,
                        horimeter: element.horimeter,
                        plate: element.plate,
                        deviceId: element.deviceId,
                        firstPositionMessage: element.firstPositionMessage,
                        lastPositionMessage: element.lastPositionMessage,
                        accumulation: element.accumulation,
                        accumulationDay: element.accumulationDay,
                        realAccumulation: element.realAccumulation,
                    });
                })

                this.setState({
                    horimeters: horimeters,
                    totalRegisters: response.data.totalRegisters,
                    lastDateConfig: response.data.lastSetting != null ? response.data.lastSetting.dateUpdatedByUser : "",
                    lastValueConfig: response.data.lastSetting != null ? response.data.lastSetting.setAccumulationByUser : "",
                    showLoading: false
                });
            })
            .catch(erros => {
                this.setState({
                    showLoading: false
                });
                if (erros.response && erros.response.status === 401) {
                    this.auth.endSession();
                    this.props.history.push('/login');
                } else if (erros.response && erros.response.status === 400) {
                    messageError("ERRO! Sem posições para a placa no período.")
                }
            })
    }

    delayOnChangeSearch = (plateName) => {
        this.setState({
            showLoading: true
        });

        this.setState({
            horimeters: [],
            totalRegisters: 0,
            lastDateConfig: "",
            lastValueConfig: "",
            showLoading: true
        });
        const startDate = typeof this.state.startDate === 'string' ? this.state.startDate : this.state.startDate.format("YYYY-MM-DD");
        const endDate = typeof this.state.endDate === 'string' ? this.state.endDate : this.state.endDate.format("YYYY-MM-DD");
        this.getData(startDate, endDate, plateName)
    }

    componentWillUnmount() {
        StorageService.removeItem("plateName");
    }


    componentDidMount() {
        this.setState({
            loading: false,
        });
    }

    render() {


        if (!this.state.loading) {
            this.getPlates();
        }


        const columns = [
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Placa</div>
                },
                align: 'center',
                dataIndex: 'plate',
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Data</div>
                },
                align: 'center',
                dataIndex: 'date',
                sorter: (a, b) => a.date - b.date,
                sortDirections: ['descend', 'ascend'],
                render: (text) => moment(text).format('DD/MM/YYYY'),
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Incremento do Dia [hh:mm]</div>
                },
                align: 'center',
                dataIndex: 'accumulationDay',
                // sorter: (a, b) => a. - b.,
                sortDirections: ['descend', 'ascend'],
                render: (text) => {
                    const hours = Math.floor(text / 60);
                    const minutes = Math.floor(text % 60);
                    return `${hours}:${minutes.toString().padStart(2, '0')}`;
                },
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Valor ao Final do Dia [hh:mm]</div>
                },
                align: 'center',
                dataIndex: 'realAccumulation',
                // sorter: (a, b) => a. - b.,
                sortDirections: ['descend', 'ascend'],
                render: (text) => {
                    const hours = Math.floor(text / 60);
                    const minutes = Math.floor(text % 60);
                    return `${hours}:${minutes.toString().padStart(2, '0')}`;
                },
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Valor ao Final do Dia Ajustado[hh:mm]</div>
                },
                align: 'center',
                dataIndex: 'accumulation',
                // sorter: (a, b) => a. - b.,
                sortDirections: ['descend', 'ascend'],
                render: (text) => {
                    const hours = Math.floor(text / 60);
                    const minutes = Math.floor(text % 60);
                    return `${hours}:${minutes.toString().padStart(2, '0')}`;
                },
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Primeiro Horário</div>
                },
                align: 'center',
                dataIndex: 'firstPositionMessage',
                sorter: (a, b) => a.date - b.date,
                sortDirections: ['descend', 'ascend'],
                render: (text) => moment(text).format('DD/MM/YYYY HH:mm:ss'),
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '12px', fontWeight: 700 }}>Último Horário</div>
                },
                align: 'center',
                dataIndex: 'lastPositionMessage',
                sorter: (a, b) => a.date - b.date,
                sortDirections: ['descend', 'ascend'],
                render: (text) => moment(text).format('DD/MM/YYYY HH:mm:ss'),
            },
        ];

        const paginationConfig = {
            defaultPageSize: this.state.tablePageSize,
            total: this.state.totalRegisters,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            onChange: (page, pageSize) => {
                this.setState({
                    tablePageSize: pageSize,
                    currentPage: page
                });

                const startDate = typeof this.state.startDate === 'string' ? this.state.startDate : this.state.startDate.format("YYYY-MM-DD");
                const endDate = typeof this.state.endDate === 'string' ? this.state.endDate : this.state.endDate.format("YYYY-MM-DD");
                const item = StorageService.getItem("plateName");
                this.getData(startDate, endDate, item);
            },
        }

        const paginationTable = this.state.totalRegisters === 0 ? false : paginationConfig;
        return (
            <MgmtLayout>

                <Row>
                    <Col span={24} >
                        {/* <Card title="Horímetro" style={{ height: '100%' }} bodyStyle={{ paddingLeft: 5, paddingRight: 5, paddingBottom: 5, paddingTop: 5 }}> */}
                        <Form title="Horímetro" ref={this.hourmeterForm} layout='vertical' style={{ height: '100%' }} bodyStyle={{ paddingLeft: 5, paddingRight: 5, paddingBottom: 5, paddingTop: 5 }} >
                            <Row>
                                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                    {/* <Select
                                        filterOption={(input, option) =>
                                            option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        filterSort={(optionA, optionB) =>
                                            optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())
                                        }
                                        onChange={e => {
                                            this.chosenPlate = e;
                                        }}
                                        placeholder="Pesquisar por placa"
                                        options={this.state.plates ? this.state.plates : null}
                                        style={{ marginBottom: '10px', width: '95%' }}
                                    /> */}

                                    <Form.Item label={<b style={{ fontSize: '15px', fontWeight: 500 }}>Placa</b>} name="placa">
                                        <Select
                                            showSearch
                                            filterOption={(input, option) =>
                                                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            filterSort={(optionA, optionB) =>
                                                optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())
                                            }
                                            onChange={e => {
                                                this.chosenPlate = e;
                                            }}
                                            allowClear
                                            onClear={() => {
                                                this.hourmeterForm.current.setFieldsValue({
                                                    placa: null,
                                                    dataInicial: null,
                                                    dataFinal: null,
                                                })
                                            }}
                                            //className="custom-select"
                                            placeholder="Pesquisar por placa"
                                            options={this.state.plates ? this.state.plates : null}
                                            style={{ marginBottom: '10px', width: '95%' }}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} xl={8} style={{ display: 'flex', alignItems: 'flex-start', justifyContent:'space-around' }}>

                                    <Form.Item label={<b style={{ fontSize: '15px', fontWeight: 500 }}>Data Inicial</b>} name="dataInicial">
                                        <DatePicker
                                            format={{
                                                format: 'YYYY-MM-DD 00:00:00',
                                                type: 'mask',
                                            }}
                                            size={'middle'}
                                            placeholder='Data Inicial'
                                            onChange={(date, dateString) => {
                                                this.setState({
                                                    startDate: dateString,
                                                });
                                            }}
                                        />
                                    </Form.Item>
                                    <Form.Item label={<b style={{ fontSize: '15px', fontWeight: 500 }}>Data Final</b>} name="dataFinal">
                                        <DatePicker
                                            format={{
                                                format: 'YYYY-MM-DD 23:59:59',
                                                type: 'mask',
                                            }}
                                            placeholder='Data Final'
                                            onChange={(date, dateString) => {
                                                this.setState({
                                                    endDate: dateString,
                                                });
                                            }}
                                        />
                                    </Form.Item>

                                </Col>
                                <Col span={24}>
                                    <Button
                                        className='successButton'
                                        type='primary'
                                        shape="round"
                                        style={{ float: 'right' }}
                                    >
                                        <CSVLink
                                            data={this.getCsv(this.state.horimeters)}
                                            separator={";"}
                                            filename={"horimetro.csv"}
                                        >
                                            Download CSV
                                        </CSVLink>
                                    </Button>

                                    <Button
                                        type="primary"
                                        shape="round"
                                        style={{ marginRight: '5px', float: 'right' }}
                                        onClick={() => {
                                            this.setState({ plateName: this.chosenPlate });
                                            StorageService.addItem("plateName", this.chosenPlate);
                                            this.delayOnChangeSearch(this.chosenPlate, 1);
                                        }}
                                    >
                                        Gerar Relatório
                                    </Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} style={{ marginTop: "15px" }}>
                                    <Table
                                        style={{ height: '100%' }}
                                        scroll={{ x: "max-content" }}
                                        loading={this.state.showLoading}
                                        columns={columns}
                                        dataSource={this.state.horimeters}
                                        onRow={(record) => ({
                                            onClick: () => {
                                                this.selectRow(record);
                                            },
                                        })}
                                        size='small'
                                        pagination={paginationTable}
                                        rowClassName={(record, index) => index % 2 === 0 ? 'row-dark ' : 'row-light'}
                                    />
                                </Col>
                            </Row>
                            {/* </Card> */}
                        </Form>
                    </Col>
                    <Col span={24}>
                        <Card style={{ height: '100%' }} >
                            <Title level={5}>{"Data da última configuração:" + (this.state.lastDateConfig === "" ? "" : moment(this.state.lastDateConfig).format("DD/MM/YYYY HH:mm:ss"))}</Title>
                            <Title level={5}>{"Valor da última configuração:" + this.state.lastValueConfig}</Title>
                        </Card>

                    </Col>
                </Row>
            </MgmtLayout>
        );
    }

}

export default withRouter(MgmtHourmeter);